import React, {useEffect, useState} from 'react';
import '../../styles/Courses.css'

const Courses = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setIsVisible(true);
        }, 100)
    }, []);

  const courses = [
    {
      title: 'B.Sc. Computer Science',
      description: 'Focus on computer programming, algorithms, and systems',
      icon: '💻',
    },
    {
      title: 'B.A.',
      description: 'Study various humanities and social science disciplines',
      icon: '🎓',
    },
    {
      title: 'B.Sc.',
      description: 'Empowering Curios Minds Through Science',
      icon: '🔬',
    },
  ];

  return (
    <div className={`courses-section ${isVisible ? 'fade-in' : ''}`}>
      <div className="heading-align-center">
      <h4 className="college-name">SHRI MULIKADEVI MAHAVIDYALAYA, NIGHOJ</h4>
      <h2 className="heading">Academic Courses</h2>
      <p className="subheading">
        Explore the diverse range of academic programs we offer.
      </p>
      
      <div className="course-cards-container">
        {courses.map((course, index) => (
          <div className="course-card" key={index}>
            <div className="course-icon">{course.icon}</div>
            <h3 className="course-title">{course.title}</h3>
            <p className="course-description">{course.description}</p>
            <button className="learn-more-button">Learn More</button>
          </div>
        ))}
      </div>
      </div>
    </div>
  );
};

export default Courses;